import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './i18n';

import AppRoutes from './Routes/appRoutes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { configureReduxStore } from './Redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import './index.css';
import { ScreenLockProvider } from './POS/Cashier/components/ScreenLock/ScreenLockContext';
import ScreenLockOverlay from './POS/Cashier/components/ScreenLock/ScreenLockOverlay';

function App() {
  const stripePromise = loadStripe('pk_test_51Kku1CLBbHIb8JaUQmSNv3YkbJHrbH1u2GaA2mkAOChyuEVYFAVHi7UotKNDnt2cSBBsYz9ebgndtPdkoXToInXP00fLEPzoyA');
  const { store, persistor } = configureReduxStore();

  return (
    <>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ScreenLockProvider>
            <Elements stripe={stripePromise}>
              <BrowserRouter>
                <AppRoutes />
                {/* Screen Lock Overlay - This will show when system is locked */}
                <ScreenLockOverlay />
              </BrowserRouter>
            </Elements>
            <ToastContainer position="top-right" autoClose={5000} />
          </ScreenLockProvider>
        </PersistGate>
      </Provider>
    </>
  );
}

export default App;
